/* eslint-disable */
// This file was automatically generated and should not be edited.

import * as Types from '../../../__generated__/globalTypes';

import { UserGeneratedPhotoFragment } from '../../ProductCarousel/__generated__/ProductCarousel';
import { gql } from '@apollo/client';
import { UserGeneratedPhotoFragmentDoc } from '../../ProductCarousel/__generated__/ProductCarousel';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type ReviewsQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
  after?: Types.Maybe<Types.Scalars['String']>;
  feature?: Types.Maybe<Types.Scalars['String']>;
  filter?: Types.Maybe<Types.ReviewFilter>;
  sort?: Types.Maybe<Types.ReviewSort>;
  hasPhoto?: Types.Maybe<Types.Scalars['Boolean']>;
  reviewText?: Types.Maybe<Types.Scalars['String']>;
}>;

export type ReviewsQuery = {
  product?: Types.Maybe<Pick<Types.Product, 'id'> & ReviewsFragment & ReviewFeaturesFragment>;
};

export type ReviewsFragment = Pick<Types.Product, 'id' | 'partNumber' | 'name'> & {
  reviews?: Types.Maybe<
    Pick<Types.ReviewConnection, 'totalCount'> & {
      pageInfo: Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>;
      edges?: Types.Maybe<
        Array<Types.Maybe<{ node?: Types.Maybe<Pick<Types.Review, 'id'> & ReviewFragment> }>>
      >;
    }
  >;
};

export type ReviewFragment = Pick<
  Types.Review,
  | 'id'
  | 'contentId'
  | 'helpfulness'
  | 'rating'
  | 'submittedAt'
  | 'submittedBy'
  | 'contributorBadge'
  | 'isIncentivized'
  | 'text'
  | 'title'
  | 'isLiked'
> & { photos: Array<Types.Maybe<UserGeneratedPhotoFragment>> };

export type LikedReviewFragment = Pick<Types.Review, 'isLiked'>;

export type ReviewFeaturesFragment = Pick<Types.Product, 'id' | 'partNumber' | 'reviewFeatures'>;

export const ReviewFragmentDoc = gql`
  fragment Review on Review {
    id
    contentId
    helpfulness
    photos {
      ...UserGeneratedPhoto
    }
    rating
    submittedAt
    submittedBy
    contributorBadge
    isIncentivized
    text
    title
    isLiked @client
  }
  ${UserGeneratedPhotoFragmentDoc}
`;
export const ReviewsFragmentDoc = gql`
  fragment Reviews on Product {
    id
    partNumber
    name
    reviews(
      after: $after
      feature: $feature
      filter: $filter
      first: 10
      sort: $sort
      hasPhoto: $hasPhoto
      reviewText: $reviewText
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          ...Review
        }
      }
    }
  }
  ${ReviewFragmentDoc}
`;
export const LikedReviewFragmentDoc = gql`
  fragment LikedReview on Review {
    isLiked @client
  }
`;
export const ReviewFeaturesFragmentDoc = gql`
  fragment ReviewFeatures on Product {
    id
    partNumber
    reviewFeatures
  }
`;
export const ReviewsDocument = gql`
  query Reviews(
    $id: String!
    $after: String
    $feature: String
    $filter: ReviewFilter
    $sort: ReviewSort = MOST_RELEVANT
    $hasPhoto: Boolean
    $reviewText: String
  ) {
    product(id: $id) {
      id
      ...Reviews
      ...ReviewFeatures
    }
  }
  ${ReviewsFragmentDoc}
  ${ReviewFeaturesFragmentDoc}
`;

/**
 * __useReviewsQuery__
 *
 * To run a query within a React component, call `useReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      feature: // value for 'feature'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      hasPhoto: // value for 'hasPhoto'
 *      reviewText: // value for 'reviewText'
 *   },
 * });
 */
export function useReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<ReviewsQuery, ReviewsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, options);
}
export function useReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReviewsQuery, ReviewsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, options);
}
export type ReviewsQueryHookResult = ReturnType<typeof useReviewsQuery>;
export type ReviewsLazyQueryHookResult = ReturnType<typeof useReviewsLazyQuery>;
export type ReviewsQueryResult = Apollo.QueryResult<ReviewsQuery, ReviewsQueryVariables>;
